import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import {
  ANDROID_BANNER_TOP_BANNER,
  ANDROID_RECOMMEND_SOFT,
  ANDROID_RECOMMEND_GROUP_SOFT,
  ANDROID_RECOMMEND_GROUP_SOFT_MORE
} from '../config';
import {
  GET_ANDROID_BANNER_TOP_BANNER,
  GET_ANDROID_BANNER_TOP_BANNER_SUCCESS,
  GET_ANDROID_RECOMMEND_SOFT,
  GET_ANDROID_RECOMMEND_SOFT_SUCCESS,
  GET_ANDROID_RECOMMEND_GROUP_SOFT,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS,
} from '../constants/arecommend';

function* fetchABanner(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_BANNER_TOP_BANNER, { params: { code: params.code } });
    if (res.data.status === 0) {
      yield put({
        type: GET_ANDROID_BANNER_TOP_BANNER_SUCCESS,
        data: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchARecommendSoft(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_RECOMMEND_SOFT, { params: params.param });
    if (res.data.status === 0) {
      yield put({
        type: GET_ANDROID_RECOMMEND_SOFT_SUCCESS,
        data: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchAGroupSoft(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_RECOMMEND_GROUP_SOFT, { params: { skip: params.skip, limit: params.limit } });
    if (res.data.status === 0) {
      yield put({
        type: GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS,
        data: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchAGroupSoftMore(params) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ANDROID_RECOMMEND_GROUP_SOFT_MORE, { params: params.param });
    if (res.data.status === 0) {
      yield put({
        type: GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS,
        data: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchABanner() {
  yield takeLatest(GET_ANDROID_BANNER_TOP_BANNER, fetchABanner);
}

export function* watchFetchARecommendSoft() {
  yield takeLatest(GET_ANDROID_RECOMMEND_SOFT, fetchARecommendSoft);
}

export function* watchFetchAGroupSoft() {
  yield takeLatest(GET_ANDROID_RECOMMEND_GROUP_SOFT, fetchAGroupSoft);
}

export function* watchFetchAGroupSoftMore() {
  yield takeLatest(GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE, fetchAGroupSoftMore);
}